<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 17:05:41
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 17:19:48
 -->
<template>
  <div class="mapContent">
    <div id="guardrailMap"></div>
    <!-- 信息窗体 -->
    <div class="deviceDetailInfowindow" ref="deviceDetailInfowindow" v-show="show">
      <span class="closeInfowindow" @click="closeInfowindow">×</span>
      <div class="title">
        <span class="type">{{deviceInfo.typeName}}：</span>
        <span class="name">{{deviceInfo.name}}</span>
      </div>
      <div class="content">
        <div class="item">
          <span class="label">所属机构：</span>
          <span class="value">{{deviceInfo.allotCompanyName}}</span>
        </div>
        <div class="item">
          <span class="label">安装时间：</span>
          <span class="value">{{deviceInfo.installTime}}</span>
        </div>
        <div class="item">
          <span class="label">安装位置：</span>
          <span class="value">{{deviceInfo.installPosition}}</span>
        </div>
        <div class="item">
          <span class="label">安装经纬度：</span>
          <span class="value">{{deviceInfo.installLng}},{{deviceInfo.installLat}}</span>
        </div>
        <div class="item">
          <span class="label">设备状态：</span>
          <span :class="deviceInfo.online ? 'online' : 'offline'">{{deviceInfo.online ? '在线' : '离线'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'mapContent',
  components: {
  },
  data () {
    return {
      mapStyle: 'amap://styles/ab56ea6d2065aadeee5cb62e09b107a1',
      cluster: null,
      deviceInfo: {},
      show: false,
    }
  },
  methods: {
    /**
     * @description                   关闭信息窗体
     * @return {undefied}             无返回值
     */
    closeInfowindow () {
      this.show = false
      window.deviceDetailInfowindow.close()
    },
    /**
     * @description: 初始化信息窗体
     * @return {undefined} 无返回值
     */
    createInfowidnow () {
      // eslint-disable-next-line no-undef
      window.deviceDetailInfowindow = new AMap.InfoWindow({
        autoMove: false,
        // closeWhenClickMap: true,
        isCustom: true, // 使用自定义窗体
        content: this.$refs.deviceDetailInfowindow,
        // eslint-disable-next-line no-undef
        offset: new AMap.Pixel(0, -65),
      })
    },
    /**
     * @description: 初始化地图
     * @param {undefined}
     * @return {undefined} 无返回值
     */
    initMap () {
      // eslint-disable-next-line no-undef
      let map = new AMap.Map('guardrailMap', {
        // zoom: 10,
        // center: [113.679865, 34.760179],
        // viewMode: '3D',
        // skyColor: '#87CEEB',
        // pitch: 60,
        mapStyle: this.mapStyle,
        animateEnable: true,
      })
      window.mapInstance = map
      // eslint-disable-next-line no-undef
      AMap.plugin('AMap.ToolBar', function () { // 异步加载插件
        // eslint-disable-next-line no-undef
        var toolbar = new AMap.ToolBar({
          locate: true,
          liteStyle: true,
          position: 'LB',
        })
        window.mapInstance.addControl(toolbar)
      })
      this.createInfowidnow()
      this.getDeviceData()
    },
    /**
     * @description: 获取设备数据
     * @return {undefined} 无返回值
     */
    getDeviceData () {
      let self = this
      this.$http.get('/rest/screen/hlpz/device/list')
        .then(res => {
          if (res.code === 0) {
            // let markers = []
            res.data.map(item => {
              item.installTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.installTime))
              // eslint-disable-next-line no-undef
              let marker = new AMap.Marker({
                position: [item.installLng, item.installLat],
              })
              // eslint-disable-next-line no-undef
              AMap.event.addListener(marker, 'click', function (e) {
                self.deviceInfo = item
                window.mapInstance.panTo([parseFloat(item.installLng), parseFloat(item.installLat) + 0.003])
                window.mapInstance.setZoom(16)
                window.deviceDetailInfowindow.open(window.mapInstance, [parseFloat(item.installLng), parseFloat(item.installLat)])
                self.show = true
              })
              // markers.push(marker)
              window.mapInstance.add(marker)
            })
            // eslint-disable-next-line no-undef
            // this.cluster = new AMap.MarkerClusterer(window.mapInstance, markers, { gridSize: 80 })
            window.mapInstance.setFitView()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.initMap()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .mapContent {
    width: 100%;
    height: 100%;
    position: relative;
    #guardrailMap {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    .deviceDetailInfowindow {
      width: 400px;
      height: 200px;
      padding: 20px;
      background: url('/static/img/layout/listBg.png');
      background-size: 100% 100%;
      position: relative;
      .closeInfowindow {
        font-size: 20px;
        color: #fff;
        cursor: pointer;
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        right: 20px;
        top: 10px;
      }
      .title {
        width: 100%;
        height: 30px;
        font-size: 16px;
        font-weight: bold;
        color: #05dbe3;
        border-bottom: 1px solid #376668;
      }
      .item {
        line-height: 30px;
        .label {
          font-size: 14px;
          color: #eee;
          display: inline-block;
          width: 86px;
          text-align: right;
        }
        .value {
          font-size: 14px;
          color: rgb(192, 192, 192);
        }
        .online {
          font-size: 14px;
          color: rgb(0, 255, 0);
        }
        .offline {
          font-size: 14px;
          color: rgb(235, 77, 111);
        }
      }
    }
  }
</style>
